import { render, staticRenderFns } from "./ControlsHolder.vue?vue&type=template&id=959b4b62&scoped=true&"
import script from "./ControlsHolder.vue?vue&type=script&lang=js&"
export * from "./ControlsHolder.vue?vue&type=script&lang=js&"
import style0 from "./ControlsHolder.vue?vue&type=style&index=0&id=959b4b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959b4b62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
